module.exports = __webpack_public_path__ + "img/zixun_6@2x.275b01c2.png";